import React from 'react'
import Tooltip from '@mui/material/Tooltip'
import IconButton from '@mui/material/IconButton'
import SettingsIcon from '@mui/icons-material/Settings'
import { useNavigate } from 'react-router-dom'
import LoanLockedAlert from './LoanLockedAlert'
import LoanSummary from './LoanSummary'
import { useLoanContext } from '../../contexts/LoanContext'
import useUser from '../../hooks/useUser'
import ButtonGroup from '../Button/ButtonGroup'
import { navigationLinking } from '../../services/navigation'

const LoanHeader = () => {
	const { loanData } = useLoanContext()
	const { isLoanAdmin } = useUser()
	const navigate = useNavigate()

	const isPosLoan = loanData?.IsPOSLoan ?? false

	const handleLoanSettingsClick = () => {
		navigate(`/${navigationLinking.LoanSettings}`)
	}

	return (
		<div className="border-b px-4 pt-3 pb-2">
			<div className="flex flex-row items-center justify-between">
				<div className="flex flex-row items-center">
					<LoanLockedAlert className="flex flex-row items-center mr-2" />
					<LoanSummary />
				</div>
				{isLoanAdmin && isPosLoan && (
					<ButtonGroup
						overflowLimit={3}
						items={[
							<Tooltip
								key="loan-settings"
								title="Loan Settings"
								arrow
							>
								<IconButton
									aria-label="loan settings"
									onClick={handleLoanSettingsClick}
									className="ml-2"
									color="inherit"
									size="small"
								>
									<SettingsIcon fontSize="small" />
								</IconButton>
							</Tooltip>,
						]}
					/>
				)}
			</div>
		</div>
	)
}

export default LoanHeader
